export default __webpack_public_path__ + "static/media/previous-icon.10cd80e7.svg";